import { DynamicImage, enLoading } from 'components/Image';
import { SportFavoriteBtn } from 'features/sport/components/sportFavoriteBtn';
import { SportsSquadraItem } from 'types/swagger/sports';
import { UsersUserDataSectionEnum } from 'types/swagger';
import { isNotEmpty } from 'utility/functions';
import styles from './SportTeamCard.module.scss';
import { useInternalSession } from 'hooks/useInternalSession';
import { useTranslation } from 'hooks/useLingUI';

export type SportTeamCardProps = {
  slug: string;
  idDisciplina: number;
  idManifestazione: number;
  favouriteTeam?: SportsSquadraItem | null;
} & SportsSquadraItem;

export const SportTeamCard = ({
  slug,
  maglia,
  name,
  idDisciplina,
  idManifestazione,
  favouriteTeam,
}: SportTeamCardProps) => {
  const { t } = useTranslation();
  const { isAuthenticated } = useInternalSession();

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {isNotEmpty(maglia) && (
          <div className={styles.imageContainer}>
            <DynamicImage
              src={`${maglia}`}
              alt={name ?? ''}
              width={16}
              height={16}
              loading={enLoading.lazy}
              className={styles.image}
            />
          </div>
        )}
        {name}
      </div>
      {isAuthenticated && (
        <SportFavoriteBtn
          favourite={name === favouriteTeam?.name}
          verticale={UsersUserDataSectionEnum.FAVORITE_SPORT_SQUADRA}
          idGame={`${idDisciplina}-${idManifestazione}-${name}`}
        />
      )}
    </div>
  );
};
